import React from "react";
import { Link } from "react-router-dom";

const SongCrossroad = () => {
  return (
    <div className="flex flex-col justify-center items-center pb-20 main h-2/3">
      <Link to="/newsong"><button className="button mb-5">Afegeix temes</button></Link>
      <br />
      <Link to="/jukebox"><button className="button mb-5">Consulta i edita temes</button></Link>
    </div>
  )
}

export default SongCrossroad;